var _defs, _use, _use2, _use3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunderstormsSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 359 231"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e2e8f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: "M295.5 223.5a56 56 0 000-112l-2.5.1a83.9 83.9 0 00-153-64.2 56 56 0 00-84.6 48.1 56.6 56.6 0 00.8 9 60 60 0 0011.2 119"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible",
    viewBox: "0 0 155.2 48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "m41.2 30.5-5.8-3.3a13.7 13.7 0 000-6.4l5.8-3.3a4 4 0 001.5-5.5 4 4 0 00-5.6-1.5l-5.8 3.3a13.6 13.6 0 00-2.6-2 13.8 13.8 0 00-3-1.2V4a4 4 0 00-8.1 0v6.6a14.3 14.3 0 00-5.7 3.2l-5.8-3.3A4 4 0 00.5 12 4 4 0 002 17.5l5.8 3.3a13.7 13.7 0 000 6.4L2 30.5A4 4 0 00.5 36a4 4 0 003.6 2 4 4 0 002-.5l5.8-3.3a13.6 13.6 0 002.6 2 13.8 13.8 0 003 1.2V44a4 4 0 008 0v-6.6a14.2 14.2 0 005.8-3.2l5.8 3.3a4 4 0 002 .5 4 4 0 003.5-2 4 4 0 00-1.4-5.5Zm-22.6-1.3a6 6 0 01-2.3-8.2 6.1 6.1 0 015.3-3 6.2 6.2 0 013 .8A6 6 0 0127 27a6.1 6.1 0 01-8.3 2.2Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 24 24; 360 24 24"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "t1",
    attributeName: "opacity",
    begin: "0s; t1.end+1s",
    dur: "2s",
    keyTimes: "0; .17; .83; 1",
    values: "0; 1; 1; 0"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    id: "s1",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; s1.end+1s",
    dur: "2s",
    type: "translate",
    values: "0 -36; 0 92;"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "m97.2 30.5-5.8-3.3a13.7 13.7 0 000-6.4l5.8-3.3a4 4 0 001.5-5.5 4 4 0 00-5.6-1.5l-5.8 3.3a13.6 13.6 0 00-2.6-2 13.8 13.8 0 00-3-1.2V4a4 4 0 00-8.1 0v6.6a14.3 14.3 0 00-5.7 3.2l-5.8-3.3a4 4 0 00-5.6 1.5 4 4 0 001.5 5.5l5.8 3.3a13.7 13.7 0 000 6.4L58 30.5a4 4 0 00-1.5 5.5 4 4 0 003.6 2 4 4 0 002-.5l5.8-3.3a13.6 13.6 0 002.6 2 13.8 13.8 0 003 1.2V44a4 4 0 008 0v-6.6a14.2 14.2 0 005.8-3.2l5.8 3.3a4 4 0 002 .5 4 4 0 003.5-2 4 4 0 00-1.4-5.5Zm-22.6-1.3a6 6 0 01-2.3-8.2 6.1 6.1 0 015.3-3 6.2 6.2 0 013 .8A6 6 0 0183 27a6.1 6.1 0 01-8.3 2.2Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 80 24; 360 80 24"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "t2",
    attributeName: "opacity",
    begin: "-.83s; t2.end+1s",
    dur: "2s",
    keyTimes: "0; .17; .83; 1",
    values: "0; 1; 1; 0"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    id: "s2",
    additive: "sum",
    attributeName: "transform",
    begin: "-.83s; s2.end+1s",
    dur: "2s",
    type: "translate",
    values: "0 -36; 0 92;"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "m153.2 30.5-5.8-3.3a13.7 13.7 0 000-6.4l5.8-3.3a4 4 0 001.5-5.5 4 4 0 00-5.6-1.5l-5.8 3.3a13.6 13.6 0 00-2.6-2 13.8 13.8 0 00-3-1.2V4a4 4 0 00-8.1 0v6.6a14.3 14.3 0 00-5.7 3.2l-5.8-3.3a4 4 0 00-5.6 1.5 4 4 0 001.5 5.5l5.8 3.3a13.7 13.7 0 000 6.4l-5.8 3.3a4 4 0 00-1.5 5.5 4 4 0 003.6 2 4 4 0 002-.5l5.8-3.3a13.6 13.6 0 002.6 2 13.8 13.8 0 003 1.2V44a4 4 0 008 0v-6.6a14.2 14.2 0 005.8-3.2l5.8 3.3a4 4 0 002 .5 4 4 0 003.5-2 4 4 0 00-1.4-5.5Zm-22.6-1.3a6 6 0 01-2.3-8.2 6.1 6.1 0 015.3-3 6.2 6.2 0 013 .8 6 6 0 012.2 8.2 6.1 6.1 0 01-8.2 2.2Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 136 24; 360 136 24"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "t3",
    attributeName: "opacity",
    begin: ".83s; t3.end+1s",
    dur: "2s",
    keyTimes: "0; .17; .83; 1",
    values: "0; 1; 1; 0"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    id: "s3",
    additive: "sum",
    attributeName: "transform",
    begin: ".83s; s3.end+1s",
    dur: "2s",
    type: "translate",
    values: "0 -36; 0 92;"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 96 176"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6a823",
    d: "M32 0 0 96h32l-16 80L96 64H48L80 0H32z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "x1",
    attributeName: "opacity",
    begin: "0s; x1.end+.67s",
    dur: "1.33s",
    keyTimes: "0; .38; .5; .63; .75; .86; .94; 1",
    values: "1; 1; 0; 1; 0; 1; 0; 1"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 359,
    height: 231,
    transform: "translate(76.5 140.5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 155.2,
    height: 48,
    transform: "translate(178.4 338)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 96,
    height: 176,
    transform: "translate(208 293)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstormsSnow);
export default __webpack_public_path__ + "static/media/thunderstorms-snow.8e010945f7e05b8d1120a846bbc392ae.svg";
export { ForwardRef as ReactComponent };